import * as jose from 'jose'

/**
 * Check if a token is a valid JWT format
 */
function isJWT(token) {
  return token && token.split('.').length === 3
}

/**
 * Decode interview token (JWT format only)
 * All interview tokens are now raw JWT tokens
 */
export function decodeInterviewToken(token) {
  if (!token) {
    throw new Error('Token is required')
  }

  if (!isJWT(token)) {
    throw new Error('Invalid JWT format. Token must be a valid JWT.')
  }

  return jose.decodeJwt(token)
}

/**
 * Get raw JWT from token (returns token as-is since all tokens are JWT)
 * All interview tokens are now raw JWT tokens
 */
export function getRawJWTFromToken(token) {
  if (!token) {
    throw new Error('Token is required')
  }

  if (!isJWT(token)) {
    throw new Error('Invalid JWT format. Token must be a valid JWT.')
  }

  return token
}
